import AxiosClient from "../../../Network/AxiosClient";
import { _downloadBlobFile } from "../../../utilities/helpers";
import { USER_TYPES } from "../../UserList/utils/userConfigs";

export const InventoryService = {
  // _downloadBlobFile: (response, defaultFileName) => {
  //   const url = window.URL.createObjectURL(new Blob([response.data]));
  //   const link = document.createElement("a");
  //   link.href = url;

  //   const contentDisposition = response.headers["content-disposition"];
  //   let fileName = defaultFileName;

  //   if (contentDisposition) {
  //     const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
  //     if (fileNameMatch) {
  //       fileName = fileNameMatch[1];
  //     }
  //   }

  //   link.setAttribute("download", fileName);
  //   document.body.appendChild(link);
  //   link.click();
  //   link.remove();
  //   window.URL.revokeObjectURL(url);

  //   return { is_error: 0, message: "File downloaded successfully" };
  // },

  // Inventory/PSB Model APIs
  createInventory: async (inventoryData) => {
    try {
      const formData = new FormData();

      formData.append("name", inventoryData.name);
      formData.append("brand", inventoryData.brand);
      formData.append("model", inventoryData.model);
      formData.append("type", inventoryData.type);
      if (inventoryData.description) {
        formData.append("description", inventoryData.description);
      }

      inventoryData.images.forEach((image, index) => {
        if (image) {
          formData.append(`images[${index + 1}]`, image);
        }
      });

      const response = await AxiosClient.post(
        `${process.env.REACT_APP_API_URL}/api/payment_speaker/v1/psb-model`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
        }
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  deactivateInventory: async (inventoryId) => {
    try {
      const response = await AxiosClient.post(
        `${process.env.REACT_APP_API_URL}/api/payment_speaker/v1/deactivate-psb-model`,
        { id: inventoryId },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Supplier APIs
  createSupplier: async (supplierData) => {
    try {
      const response = await AxiosClient.post(
        `${process.env.REACT_APP_API_URL}/api/payment_speaker/v1/psb-supplier`,
        {
          name: supplierData.name,
          code: supplierData.code,
          poc_name: supplierData.poc_name,
          contact_number: supplierData.contact_number,
          address: supplierData.address,
          description: supplierData.description,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
        }
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  deactivateSupplier: async (supplierId) => {
    try {
      const response = await AxiosClient.post(
        `${process.env.REACT_APP_API_URL}/api/payment_speaker/v1/deactivate-psb-supplier`,
        { id: supplierId },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // PO APIs
  createPO: async (poData) => {
    try {
      const formData = new FormData();

      // Add basic PO fields
      formData.append("po_number", poData.po_number);
      formData.append("po_initiator", poData.po_initiator);
      formData.append("model_type", poData.model_type);
      formData.append("supplier", poData.supplier);
      formData.append("description", poData.description);

      // Add device info as JSON string
      formData.append("device_info", JSON.stringify(poData.device_info));

      // Add attachment if exists
      if (poData.attachment) {
        formData.append("attachment", poData.attachment);
      }

      const response = await AxiosClient.post(
        `${process.env.REACT_APP_API_URL}/api/payment_speaker/v1/psb-po`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
        }
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Warehouse APIs
  createWarehouse: async (warehouseData) => {
    try {
      const response = await AxiosClient.post(
        `${process.env.REACT_APP_API_URL}/api/payment_speaker/v1/psb-warehouse`,
        {
          name: warehouseData.name,
          address: warehouseData.address,
          poc: warehouseData.poc,
          owner: warehouseData.owner,
          lat: parseFloat(warehouseData.lat),
          lng: parseFloat(warehouseData.lng),
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
        }
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Warehouse Manager APIs
  createWarehouseManager: async (managerData) => {
    try {
      const response = await AxiosClient.post(
        `${process.env.REACT_APP_API_URL}/api/users/api/v1/user`,
        {
          name: managerData.name,
          username: managerData.email,
          email: managerData.email,
          password: managerData.password,
          contact_number: managerData.contact_number,
          user_type: USER_TYPES.WAREHOUSE_MANAGER,
          warehouse: managerData.warehouse,
          joining_date: managerData.joining_date,
        }
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updateWarehouseManager: async (managerId, managerData) => {
    try {
      const requestData = {
        name: managerData.name,
        username: managerData.email,
        email: managerData.email,
        contact_number: managerData.contact_number,
        user_type: USER_TYPES.WAREHOUSE_MANAGER,
        warehouse: managerData.warehouse,
        joining_date: managerData.joining_date,
      };

      if (managerData.password && managerData.password.trim() !== "") {
        requestData.password = managerData.password;
      }

      const response = await AxiosClient.put(
        `${process.env.REACT_APP_API_URL}/api/users/api/v1/user`,
        {
          id: managerId,
          ...requestData,
        }
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  deactivateWarehouseManager: async (managerId) => {
    try {
      const response = await AxiosClient.delete(
        `${process.env.REACT_APP_API_URL}/api/users/api/v1/user`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
          data: { id: managerId },
        }
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  createChargingPlan: async (planData) => {
    try {
      const formData = new FormData();

      formData.append("name", planData.name);
      formData.append("scheme_type", planData.scheme_type);
      formData.append("device_model", planData.device_model);
      formData.append("up_front_amount", planData.up_front_amount || 0);
      formData.append("emi_amount", planData.emi_amount || 0);
      formData.append("emi_count", planData.emi_count || 0);
      formData.append("emi_frequency", planData.emi_frequency || "");

      if (planData.attachment) {
        formData.append("attachment", planData.attachment);
      }

      const response = await AxiosClient.post(
        `${process.env.REACT_APP_API_URL}/api/payment_speaker/v1/psb-scheme`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
        }
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  deactivateChargingPlan: async (planId) => {
    try {
      const response = await AxiosClient.post(
        `${process.env.REACT_APP_API_URL}/api/payment_speaker/v1/deactivate-psb-scheme`,
        { id: planId },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
        }
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  uploadReceiveStock: async (inventoryType, file) => {
    try {
      const formData = new FormData();
      formData.append("inventory_type", inventoryType);
      formData.append("file", file);

      const response = await AxiosClient.post(
        `${process.env.REACT_APP_API_URL}/api/payment_speaker/upload/receive-stock`,
        formData,
        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
            "Content-Type": "multipart/form-data",
          },
          responseType: "blob",
        }
      );

      const contentType = response.headers["content-type"];
      if (contentType && contentType.includes("application/json")) {
        const text = await response.data.text();
        return JSON.parse(text);
      } else {
        return _downloadBlobFile(response, "receive-stock-result.xlsx");
      }
    } catch (error) {
      if (error.response && error.response.data instanceof Blob) {
        try {
          const errorText = await error.response.data.text();
          const errorData = JSON.parse(errorText);
          error.response.data = errorData;
        } catch (parseError) {
          console.error("Error parsing blob error response:", parseError);
        }
      }
      throw error;
    }
  },

  updateWarranty: async (inventoryType, file) => {
    try {
      const formData = new FormData();
      formData.append("inventory_type", inventoryType);
      formData.append("file", file);

      const response = await AxiosClient.post(
        `${process.env.REACT_APP_API_URL}/api/payment_speaker/upload/update-warranty`,
        formData,
        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
            "Content-Type": "multipart/form-data",
          },
          responseType: "blob",
        }
      );

      const contentType = response.headers["content-type"];
      if (contentType && contentType.includes("application/json")) {
        const text = await response.data.text();
        return JSON.parse(text);
      } else {
        return _downloadBlobFile(response, "warranty-update-result.xlsx");
      }
    } catch (error) {
      if (error.response && error.response.data instanceof Blob) {
        try {
          const errorText = await error.response.data.text();
          const errorData = JSON.parse(errorText);
          error.response.data = errorData;
        } catch (parseError) {
          console.error("Error parsing blob error response:", parseError);
        }
      }
      throw error;
    }
  },

  uploadNewStock: async (stockData, file) => {
    try {
      const formData = new FormData();

      formData.append("warehouse_unique_id", stockData.warehouse_unique_id);
      formData.append("inventory_type", stockData.inventory_type);
      formData.append("po_number", stockData.po_number);
      formData.append("warehouse_entry_date", stockData.warehouse_entry_date);
      formData.append("file", file);

      const response = await AxiosClient.post(
        `${process.env.REACT_APP_API_URL}/api/payment_speaker/upload/new-stock`,
        formData,
        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
            "Content-Type": "multipart/form-data",
          },
          responseType: "blob",
        }
      );

      const contentType = response.headers["content-type"];
      if (contentType && contentType.includes("application/json")) {
        const text = await response.data.text();
        return JSON.parse(text);
      } else {
        return _downloadBlobFile(response, "new-stock-result.xlsx");
      }
    } catch (error) {
      if (error.response && error.response.data instanceof Blob) {
        try {
          const errorText = await error.response.data.text();
          const errorData = JSON.parse(errorText);
          error.response.data = errorData;
        } catch (parseError) {
          console.error("Error parsing blob error response:", parseError);
        }
      }
      throw error;
    }
  },

  uploadRolloutMapping: async (file) => {
    try {
      const formData = new FormData();

      formData.append("file", file);

      const response = await AxiosClient.post(
        `${process.env.REACT_APP_API_URL}/api/payment_speaker/upload/rollout-mapping`,
        formData,
        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
            "Content-Type": "multipart/form-data",
          },
          responseType: "blob",
        }
      );

      const contentType = response.headers["content-type"];
      if (contentType && contentType.includes("application/json")) {
        const text = await response.data.text();
        return JSON.parse(text);
      } else {
        return _downloadBlobFile(response, "rollout-mapping-result.xlsx");
      }
    } catch (error) {
      if (error.response && error.response.data instanceof Blob) {
        try {
          const errorText = await error.response.data.text();
          const errorData = JSON.parse(errorText);
          error.response.data = errorData;
        } catch (parseError) {
          console.error("Error parsing blob error response:", parseError);
        }
      }
      throw error;
    }
  },

  uploadUnbindingRequest: async (file) => {
    try {
      const formData = new FormData();
      formData.append("file", file);

      const response = await AxiosClient.post(
        `${process.env.REACT_APP_API_URL}/api/payment_speaker/upload/approve-unbind-request`,
        formData,
        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
            "Content-Type": "multipart/form-data",
          },
          responseType: "blob",
        }
      );
      const contentType = response.headers["content-type"];
      if (contentType && contentType.includes("application/json")) {
        const text = await response.data.text();
        return JSON.parse(text);
      } else {
        return _downloadBlobFile(response, "unbinding-request-result.xlsx");
      }
    } catch (error) {
      if (error.response && error.response.data instanceof Blob) {
        try {
          const errorText = await error.response.data.text();
          const errorData = JSON.parse(errorText);
          error.response.data = errorData;
        } catch (parseError) {
          console.error("Error parsing blob error response:", parseError);
        }
      }
      throw error;
    }
  },

  createInventoryTransfer: async (transferData) => {
    try {
      const formData = new FormData();

      formData.append("transfer_type", transferData.transfer_type);
      formData.append("source_type", transferData.source_type);
      formData.append("source_id", transferData.source_id);
      formData.append("destination_type", transferData.destination_type);
      formData.append("destination_id", transferData.destination_id);
      formData.append("transfer_reason", transferData.transfer_reason);
      formData.append("inventory_type", transferData.inventory_type);
      formData.append("handover_date", transferData.handover_date);
      formData.append("transit_via", transferData.transit_via);
      formData.append("transit_type", transferData.transit_type);

      if (transferData.receiver_name) {
        formData.append("receiver_name", transferData.receiver_name);
      }
      if (transferData.receiver_designation) {
        formData.append(
          "receiver_designation",
          transferData.receiver_designation
        );
      }
      if (transferData.receiver_employee_id) {
        formData.append(
          "receiver_employee_id",
          transferData.receiver_employee_id
        );
      }
      if (transferData.receiver_email) {
        formData.append("receiver_email", transferData.receiver_email);
      }
      if (transferData.receiver_phone) {
        formData.append("receiver_phone", transferData.receiver_phone);
      }

      if (transferData.courier_name) {
        formData.append("courier_name", transferData.courier_name);
      }
      if (transferData.courier_tracking_number) {
        formData.append(
          "courier_tracking_number",
          transferData.courier_tracking_number
        );
      }

      if (transferData.file) {
        formData.append("file", transferData.file);
      }

      const response = await AxiosClient.post(
        `${process.env.REACT_APP_API_URL}/api/payment_speaker/upload/initiate-new-transfer`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
          responseType: "blob",
        }
      );

      const contentType = response.headers["content-type"];
      if (contentType && contentType.includes("application/json")) {
        const text = await response.data.text();
        return JSON.parse(text);
      } else {
        return _downloadBlobFile(response, "transfer-result.xlsx");
      }
    } catch (error) {
      if (error.response && error.response.data instanceof Blob) {
        try {
          const errorText = await error.response.data.text();
          const errorData = JSON.parse(errorText);
          error.response.data = errorData;
        } catch (parseError) {
          console.error("Error parsing blob error response:", parseError);
        }
      }
      throw error;
    }
  },

  downloadSampleFile: async (endpoint, fileName = "sample-file.xlsx") => {
    try {
      const response = await AxiosClient.get(endpoint, {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
        },
        responseType: "blob",
      });
      _downloadBlobFile(response, fileName);
      return { success: true };
    } catch (error) {
      console.error("Error downloading sample file:", error);
      throw error;
    }
  },
};

export const inventoryFetcher = async (url) => {
  const response = await AxiosClient.get(url, {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
    },
  });
  return response.data;
};
